import React from 'react';
import { useLocation } from 'react-router-dom';
import NavLinkMenu from './utilities/NavLinkMenu';
import ThreadsIcon from './icons/ThreadsIcon';
import ThreadsSolidIcon from './icons/ThreadsSolidIcon';
import MessageIcon from './icons/MessageIcon';
import MessageSolidIcon from './icons/MessageSolidIcon';
import RankingIcon from './icons/RankingIcon';
import RankingSolidIcon from './icons/RankingSolidIcon';
import UserIcon from './icons/UserIcon';
import UserSolidIcon from './icons/UserSolidIcon';

export default function NavMenu() {
  const { pathname } = useLocation();
  return (
    <nav className="flex justify-between gap-x-6 lg:gap-x-8 items-center fixed bottom-0 inset-x-0 w-full md:w-auto md:bottom-auto md:inset-x-auto md:static px-6 md:px-0 py-2 md:py-0 sm:mr-2 md:mr-8 border-t dark:border-zinc-50/20 md:border-none md:max-w-max bg-white dark:bg-zinc-800">
      <NavLinkMenu
        to="/"
        label="Threads"
        icon={pathname === '/' ? <ThreadsSolidIcon /> : <ThreadsIcon />}
      />
      <NavLinkMenu
        to="/leaderboard"
        label="Leaderboard"
        icon={
          pathname === '/leaderboard' ? <RankingSolidIcon /> : <RankingIcon />
        }
      />
      <NavLinkMenu
        to="/my-threads"
        label="My Threads"
        icon={
          pathname === '/my-threads' ? <MessageSolidIcon /> : <MessageIcon />
        }
      />
      <NavLinkMenu
        to="/my-profile"
        label="My Profile"
        icon={pathname === '/my-profile' ? <UserSolidIcon /> : <UserIcon />}
      />
    </nav>
  );
}
